<script>
  import Chart from "chart.js/auto";
  import { onMount } from "svelte";
  import { urlServeur } from "../conf.js";

  let axeBenef;
  let serieBenef;
  let ctx;
  let chartCanvas;
  const chartType = "bar";

  /**
   *
   */
  const fetchData = async () => {
    const response = await fetch(urlServeur + "/api/immeubles/graphcumulbenef");
    const result = await response.json();

    axeBenef = JSON.parse(result.payload.axe);
    serieBenef = JSON.parse(result.payload.serie);

    ctx = chartCanvas.getContext("2d");
    var chart = new Chart(ctx, {
      type: chartType,
      data: {
        labels: axeBenef,
        datasets: [
          {
            label: "Repart. par Bénef.",
            backgroundColor: [
              "rgba(255, 99, 132)",
              "rgba(54, 162, 235)",
              "rgba(255, 206, 86)",
              "rgba(75, 192, 192)",
              "rgba(153, 102, 255)",
              "rgba(255, 159, 64)",
            ],
            borderColor: [
              "rgba(255, 99, 132, 1)",
              "rgba(54, 162, 235, 1)",
              "rgba(255, 206, 86, 1)",
              "rgba(75, 192, 192, 1)",
              "rgba(153, 102, 255, 1)",
              "rgba(255, 159, 64, 1)",
            ],
            data: serieBenef,
          },
        ],
      },
      options: {
        legend: {
          display: false,
          position: "bottom",
          labels: {
            fontColor: "#000080",
          },
        },
      },
    });
  };

  /**
   *
   */
  onMount(async () => {
    await fetchData();
  });
</script>

<canvas id="myChart" bind:this={chartCanvas} />

{#if serieBenef != undefined && axeBenef != undefined}
  <div class="container">
    <h6>Répartition</h6>

    <div class="row tableau">
      <br />
      <table width="80%" class="table-primary table-bordered border-primary">
        <thead>
          <tr>
            <td>Nom</td>
            <td>Mont</td>
          </tr>
        </thead>

        <tbody>
          {#each axeBenef as item, index}
            <tr>
              <td>{item} </td>
              <td>{new Intl.NumberFormat("fr-FR").format(serieBenef[index])}</td
              >
            </tr>
          {/each}
        </tbody>
      </table>
    </div>

  </div>
{/if}
<style>
    .tableau{
        width: 100%;
	    margin: auto;
    }
</style>
